<script lang="ts" setup>
interface Props{
  label: string;
  icon?: string;
  color?: string;
}

const props = defineProps<Props>();

const icon = computed(() => {
  if (props.icon) {
    return props.icon;
  } else {
    return 'fa-circle-info';
  }
});

const color = computed(() => {
  if (props.color) {
    return props.color;
  } else {
    return 'primary';
  }
});

const fill = computed(() => {
  // solid icon is default
  return props.icon?.includes('fa-light') ? 'fa-fw fa-light' : 'fa-fw fa-solid';
});
</script>

<template>
  <IonText
    :color="color"
    class="ion-float-left"
  >
    {{ label }}
    <i :class="[icon, fill]" />
  </IonText>
</template>

  <style scoped>

  </style>
